var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgSwapAmountTo = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.47144 7.95143C2.2052 7.98809 2 8.21969 2 8.49993C2 8.80564 2.24421 9.05347 2.54545 9.05347H12.1333L8.6698 12.5542L8.61686 12.6162C8.45797 12.8326 8.47495 13.1401 8.6682 13.3371C8.88077 13.5537 9.22613 13.5544 9.43959 13.3387L13.8318 8.89973C13.858 8.87429 13.8816 8.84623 13.9024 8.81597C14.0511 8.5998 14.0301 8.29995 13.8396 8.10737L9.43955 3.66129L9.37826 3.60782C9.16439 3.4475 8.8614 3.46603 8.66817 3.66297C8.45561 3.87961 8.45636 4.2301 8.66983 4.4458L12.1342 7.94638L2.54545 7.94638L2.47144 7.95143Z",
    fill: "#08CD1F"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSwapAmountTo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/swap-amount-to.b113dc78.svg";
export { ForwardRef as ReactComponent };